import { css, type Theme } from "@emotion/react";

import * as layers from "@styles/emotion-styles/layers";

export const iconWrapper = {
  base: css`
    display: flex;
    flex: 1;
    overflow: visible;
    position: relative;
  `,
  wrapperAlignment: {
    start: css`
      align-items: flex-start;
    `,
    end: css`
      align-items: flex-end;
    `,
    center: css`
      align-items: center;
    `,
  },
};

export const tooltip = css`
  position: absolute;
  right: 0.75rem;
  top: 1rem;
  padding: 0;
  z-index: ${layers.indexTooltip};
`;

export const icon = {
  base: css`
    line-height: 1;
    position: absolute;
    right: 0;
    z-index: ${layers.indexTooltipMin};
  `,
  hasTooltip: css`
    position: static;
    right: auto;
    bottom: auto;
  `,
  iconPosition: {
    top: css`
      top: 0;
    `,
    right: css`
      right: 0;
    `,
    bottom: css`
      bottom: 0;
    `,
    left: css`
      left: 0;
    `,
    topRight: css`
      top: -0.5rem;
      right: -0.5rem;
    `,
    topLeft: css`
      top: -0.5rem;
      left: -0.5rem;
    `,
    bottomRight: css`
      bottom: -0.5rem;
      right: -0.5rem;
    `,
    bottomLeft: css`
      bottom: -0.5rem;
      left: -0.5rem;
    `,
  },
  variations: {
    primary: (theme: Theme) => css`
      color: ${theme.success.textBase};
    `,
    danger: (theme: Theme) => css`
      color: ${theme.danger.textBase};
    `,
    warning: (theme: Theme) => css`
      color: ${theme.warning.textBase};
    `,
    purple: (theme: Theme) => css`
      color: ${theme.highlight.textBase};
    `,
    info: (theme: Theme) => css`
      color: ${theme.success.textBase};
    `,
  },
};
